export default "__VITE_ASSET__BnZCgeaD__"